import axios from 'axios';
var getRequestHeaders = function getRequestHeaders(csrfToken, responseType) {
  var data = {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': csrfToken
    }
  };
  if (responseType) {
    data.responseType = responseType;
  }
  return data;
};
var errorHandler = function errorHandler(err) {
  if (err && err.response && err.response.data) {
    throw err.response.data;
  } else {
    throw err.message;
  }
};
export var getRequest = function getRequest(url, params) {
  return axios.get(url, {
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    },
    params: params
  })["catch"](errorHandler);
};
export var postRequest = function postRequest(url, data, csrfToken, responseType) {
  return axios.post(url, data, getRequestHeaders(csrfToken, responseType))["catch"](errorHandler);
};
export var putRequest = function putRequest(url, data, csrfToken) {
  return axios.put(url, data, getRequestHeaders(csrfToken))["catch"](errorHandler);
};
export var postFileRequest = function postFileRequest(url, file, csrfToken, skipParsing) {
  var formData = new FormData();
  formData.append('file', file);
  if (skipParsing) formData.append('skip_parsing', 'true');
  return axios.post(url, formData, getRequestHeaders(csrfToken))["catch"](errorHandler);
};
export var deleteRequest = function deleteRequest(url, csrfToken) {
  return axios["delete"](url, getRequestHeaders(csrfToken))["catch"](errorHandler);
};